var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.loadError
    ? _c(
        "contentBox",
        { attrs: { loading: _vm.loading } },
        [
          _vm.zoning
            ? _c(
                "contentTitle",
                { attrs: { label: "EDIT ZONING", close: _vm.routeClose } },
                [
                  _c(
                    "h2",
                    { staticClass: "text-white font-weight-light pb-2" },
                    [_vm._v(_vm._s(_vm.zoning.designation))]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.zoning
            ? _c(
                "contentBody",
                { attrs: { locked: _vm.token === null || !_vm.isAdmin } },
                [
                  _c("div", { staticClass: "p-3" }, [
                    _vm.token === null || !_vm.isAdmin
                      ? _c("div", { staticClass: "lock-block" }, [
                          _c(
                            "div",
                            {
                              staticClass: "row mx-0 hover-dk",
                              on: { click: _vm.routeLogin }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "col-2 text-center my-auto" },
                                [
                                  _c(
                                    "i",
                                    {
                                      staticClass:
                                        "material-icons text-light mr-3 md-36"
                                    },
                                    [_vm._v("account_box")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "py-3 col-10 pl-0 pr-3 py-3" },
                                [
                                  _c("h5", { staticClass: "mb-0 text-white" }, [
                                    _vm._v("Sign in to edit")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "h5",
                                    {
                                      staticClass:
                                        "mb-0 font-weight-light text-light"
                                    },
                                    [
                                      _vm._v(
                                        "You must be signed in as an admin to edit this record"
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.token !== null && _vm.isAdmin
                      ? _c(
                          "div",
                          { staticClass: "category-body" },
                          [
                            _vm.mode === "detailsEdit"
                              ? _c(
                                  "div",
                                  { staticClass: "section section-bold" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "section-title" },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\tEdit Details\n\t\t\t\t\t\t"
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "category-title-btn",
                                            on: {
                                              click: function($event) {
                                                return _vm.setMode(null)
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "i",
                                              {
                                                staticClass:
                                                  "material-icons md-14"
                                              },
                                              [_vm._v("close")]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "section-body" }, [
                                      _c(
                                        "div",
                                        { staticClass: "category-title" },
                                        [_vm._v("JURISDICTION")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "property-row" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "text-description" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.zoning.jurisdiction.name
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "category" }, [
                                        _c(
                                          "div",
                                          { staticClass: "category-title" },
                                          [_vm._v("DESCRIPTION")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "property-row" },
                                          [
                                            _c("textarea", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.rec.description,
                                                  expression: "rec.description"
                                                }
                                              ],
                                              staticClass: "form-control",
                                              domProps: {
                                                value: _vm.rec.description
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.rec,
                                                    "description",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            })
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "category" }, [
                                        _c(
                                          "div",
                                          { staticClass: "category-title" },
                                          [_vm._v("USE")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "property-row" },
                                          [
                                            _c("label", [_vm._v("Primary")]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "property-value-right"
                                              },
                                              [
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName:
                                                          "v-model.string",
                                                        value:
                                                          _vm.rec.use.primary,
                                                        expression:
                                                          "rec.use.primary",
                                                        modifiers: {
                                                          string: true
                                                        }
                                                      }
                                                    ],
                                                    staticClass:
                                                      "form-control form-control-sm",
                                                    attrs: {
                                                      placeholder: "primary use"
                                                    },
                                                    on: {
                                                      change: [
                                                        function($event) {
                                                          var $$selectedVal = Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function(o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function(o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                          _vm.$set(
                                                            _vm.rec.use,
                                                            "primary",
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                          )
                                                        },
                                                        _vm.primaryUseChange
                                                      ]
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "option",
                                                      { attrs: { value: "" } },
                                                      [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t\t** blank **\n\t\t\t\t\t\t\t\t\t\t"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      _vm.zoningUses.primary,
                                                      function(use) {
                                                        return _c(
                                                          "option",
                                                          {
                                                            domProps: {
                                                              value: use
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(use) +
                                                                "\n\t\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  ],
                                                  2
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "property-row" },
                                          [
                                            _c("label", [_vm._v("Secondary")]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "property-value-right"
                                              },
                                              [
                                                !_vm.rec.use.primary
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\tSelect a primary use\n\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ])
                                                  : !_vm.zoningUses.secondary[
                                                      _vm.rec.use.primary
                                                    ]
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\tNo secondary uses for " +
                                                          _vm._s(
                                                            _vm.rec.use.primary
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ])
                                                  : _c(
                                                      "select",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName:
                                                              "v-model.string",
                                                            value:
                                                              _vm.rec.use
                                                                .secondary,
                                                            expression:
                                                              "rec.use.secondary",
                                                            modifiers: {
                                                              string: true
                                                            }
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control form-control-sm",
                                                        attrs: {
                                                          placeholder:
                                                            "secondary use"
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            var $$selectedVal = Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function(o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function(o) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                            _vm.$set(
                                                              _vm.rec.use,
                                                              "secondary",
                                                              $event.target
                                                                .multiple
                                                                ? $$selectedVal
                                                                : $$selectedVal[0]
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "option",
                                                          {
                                                            attrs: { value: "" }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t** blank **\n\t\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          _vm.zoningUses
                                                            .secondary[
                                                            _vm.rec.use.primary
                                                          ],
                                                          function(use) {
                                                            return _c(
                                                              "option",
                                                              {
                                                                domProps: {
                                                                  value: use
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      use
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          }
                                                        )
                                                      ],
                                                      2
                                                    )
                                              ]
                                            )
                                          ]
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "section-footer" },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-sm btn-primary float-right",
                                            on: { click: _vm.saveDetails }
                                          },
                                          [_vm._v("Save")]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _c("div", { staticClass: "section" }, [
                                  _c("div", { staticClass: "section-title" }, [
                                    _vm._v(
                                      "\n\t\t\t\t\t\tDetails\n\t\t\t\t\t\t"
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "category-title-btn",
                                        on: {
                                          click: function($event) {
                                            return _vm.setMode("detailsEdit")
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "i",
                                          {
                                            staticClass: "material-icons md-14"
                                          },
                                          [_vm._v("edit")]
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "section-body" }, [
                                    _c(
                                      "div",
                                      { staticClass: "category-title" },
                                      [_vm._v("JURISDICTION")]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "property-row" }, [
                                      _c(
                                        "div",
                                        { staticClass: "text-description" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.zoning.jurisdiction.name)
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "category" }, [
                                      _c(
                                        "div",
                                        { staticClass: "category-title" },
                                        [_vm._v("DESCRIPTION")]
                                      ),
                                      _vm._v(" "),
                                      _vm.zoning.description
                                        ? _c(
                                            "div",
                                            { staticClass: "property-row" },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm.zoning.description
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t"
                                              )
                                            ]
                                          )
                                        : _c("span", { staticClass: "undef" }, [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t-\n\t\t\t\t\t\t\t"
                                            )
                                          ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "category" }, [
                                      _c(
                                        "div",
                                        { staticClass: "category-title" },
                                        [_vm._v("USE")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "property-row" },
                                        [
                                          _c("label", [_vm._v("Primary")]),
                                          _vm._v(" "),
                                          _vm.zoning.use.primary
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "property-value-right"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.zoning.use.primary
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "undef property-value-right"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t-\n\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "property-row" },
                                        [
                                          _c("label", [_vm._v("Secondary")]),
                                          _vm._v(" "),
                                          _vm.zoning.use.secondary
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "property-value-right"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.zoning.use.secondary
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "undef property-value-right"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t-\n\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              )
                                        ]
                                      )
                                    ])
                                  ])
                                ]),
                            _vm._v(" "),
                            _vm._l(_vm.zoning.regulations, function(
                              regulation,
                              regInd
                            ) {
                              return _c(
                                "div",
                                [
                                  _vm.mode === "regulationEdit" &&
                                  _vm.regulationEditInd === regInd
                                    ? _c("regulationForm", {
                                        attrs: {
                                          regulation:
                                            _vm.zoning.regulations[regInd],
                                          submitLabel: "Save",
                                          title:
                                            "Edit Regulation " + (regInd + 1)
                                        },
                                        on: {
                                          close: function($event) {
                                            return _vm.setMode(null)
                                          },
                                          submit: _vm.regulationSave
                                        }
                                      })
                                    : _vm.mode === "regulationDelete" &&
                                      _vm.regulationDeleteInd === regInd
                                    ? _c(
                                        "div",
                                        { staticClass: "section section-bold" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "section-title" },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\tDelete Regulation " +
                                                  _vm._s(regInd + 1) +
                                                  "\n\t\t\t\t\t\t\t"
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "category-title-btn",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setMode(null)
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "material-icons md-14"
                                                    },
                                                    [_vm._v("close")]
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "section-body" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "property-row" },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\tAre you sure you want to delete this regulation?\n\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "section-footer" },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-sm btn-danger float-right",
                                                  on: {
                                                    click:
                                                      _vm.regulationDeleteSubmit
                                                  }
                                                },
                                                [_vm._v("Delete")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _c("div", { staticClass: "section" }, [
                                        _c(
                                          "div",
                                          { staticClass: "section-title" },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\tRegulation " +
                                                _vm._s(regInd + 1) +
                                                "\n\t\t\t\t\t\t\t"
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "category-title-btn",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.regulationDelete(
                                                      regInd
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "i",
                                                  {
                                                    staticClass:
                                                      "material-icons md-14"
                                                  },
                                                  [_vm._v("delete")]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "category-title-btn",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.regulationEdit(
                                                      regInd
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "i",
                                                  {
                                                    staticClass:
                                                      "material-icons md-14"
                                                  },
                                                  [_vm._v("edit")]
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "section-body" },
                                          [
                                            regulation.lotSize.minArea !==
                                              null ||
                                            regulation.lotSize.maxArea !==
                                              null ||
                                            regulation.lotSize.minWidth !==
                                              null ||
                                            regulation.lotSize
                                              .minWidthCorner !== null ||
                                            regulation.lotSize.minFrontage !==
                                              null ||
                                            regulation.lotSize.minDepth !== null
                                              ? _c(
                                                  "div",
                                                  { staticClass: "category" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "category-title"
                                                      },
                                                      [_vm._v("LOT SIZE")]
                                                    ),
                                                    _vm._v(" "),
                                                    regulation.lotSize
                                                      .minArea !== null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "property-row"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                "Minimum area"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "property-value-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "integerLg"
                                                                      )(
                                                                        regulation
                                                                          .lotSize
                                                                          .minArea
                                                                      )
                                                                    ) +
                                                                    " ft²\n\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    regulation.lotSize
                                                      .maxArea !== null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "property-row"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                "Maximum area"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "property-value-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "integerLg"
                                                                      )(
                                                                        regulation
                                                                          .lotSize
                                                                          .maxArea
                                                                      )
                                                                    ) +
                                                                    " ft²\n\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    regulation.lotSize
                                                      .minWidth !== null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "property-row"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                "Minimum width"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "property-value-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "integerLg"
                                                                      )(
                                                                        regulation
                                                                          .lotSize
                                                                          .minWidth
                                                                      )
                                                                    ) +
                                                                    " ft\n\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    regulation.lotSize
                                                      .minWidthCorner !== null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "property-row"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                "Minimum width corner"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "property-value-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "integerLg"
                                                                      )(
                                                                        regulation
                                                                          .lotSize
                                                                          .minWidthCorner
                                                                      )
                                                                    ) +
                                                                    " ft\n\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    regulation.lotSize
                                                      .minFrontage !== null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "property-row"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                "Minimum frontage"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "property-value-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "integerLg"
                                                                      )(
                                                                        regulation
                                                                          .lotSize
                                                                          .minFrontage
                                                                      )
                                                                    ) +
                                                                    " ft\n\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    regulation.lotSize
                                                      .minDepth !== null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "property-row"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                "Minimum depth"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "property-value-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "integerLg"
                                                                      )(
                                                                        regulation
                                                                          .lotSize
                                                                          .minDepth
                                                                      )
                                                                    ) +
                                                                    " ft\n\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            regulation.density.sfDu !== null ||
                                            regulation.density.sfDuNote !== null
                                              ? _c(
                                                  "div",
                                                  { staticClass: "category" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "category-title"
                                                      },
                                                      [_vm._v("DENSITY")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "property-row"
                                                      },
                                                      [
                                                        _c("label", [
                                                          _vm._v("SF/DU")
                                                        ]),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "property-value-right"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "integerLg"
                                                                  )(
                                                                    regulation
                                                                      .density
                                                                      .sfDu
                                                                  )
                                                                ) +
                                                                "\n\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    regulation.density
                                                      .sfDuNote !== null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "property-row"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                "SF/DU note"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "property-value-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      regulation
                                                                        .density
                                                                        .sfDuNote
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            regulation.heightLimit.max !==
                                              null ||
                                            regulation.heightLimit
                                              .aboveEnclosedParking !== null ||
                                            regulation.heightLimit.roofFlat !==
                                              null ||
                                            regulation.heightLimit
                                              .roofPitched !== null
                                              ? _c(
                                                  "div",
                                                  { staticClass: "category" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "category-title"
                                                      },
                                                      [_vm._v("HEIGHT LIMIT")]
                                                    ),
                                                    _vm._v(" "),
                                                    regulation.heightLimit
                                                      .max !== null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "property-row"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                "Height maximum"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "property-value-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "integerLg"
                                                                      )(
                                                                        regulation
                                                                          .heightLimit
                                                                          .max
                                                                      )
                                                                    ) +
                                                                    " ft\n\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    regulation.heightLimit
                                                      .aboveEnclosedParking !==
                                                    null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "property-row"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                "Above enclosed parking"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "property-value-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "integerLg"
                                                                      )(
                                                                        regulation
                                                                          .heightLimit
                                                                          .aboveEnclosedParking
                                                                      )
                                                                    ) +
                                                                    " ft\n\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    regulation.heightLimit
                                                      .roofFlat !== null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "property-row"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                "Roof flat limit"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "property-value-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "integerLg"
                                                                      )(
                                                                        regulation
                                                                          .heightLimit
                                                                          .roofFlat
                                                                      )
                                                                    ) +
                                                                    " ft\n\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    regulation.heightLimit
                                                      .roofPitched !== null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "property-row"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                "Roof pitched limit"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "property-value-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "integerLg"
                                                                      )(
                                                                        regulation
                                                                          .heightLimit
                                                                          .roofPitched
                                                                      )
                                                                    ) +
                                                                    " ft\n\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    regulation.heightLimit
                                                      .note !== null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "property-row"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                "Height note"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "property-value-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      regulation
                                                                        .heightLimit
                                                                        .note
                                                                    ) +
                                                                    " ft\n\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            regulation.far.base !== null ||
                                            regulation.far.min !== null ||
                                            regulation.far.max !== null ||
                                            regulation.far.residential !==
                                              null ||
                                            regulation.far.commercial !==
                                              null ||
                                            regulation.far.mixed !== null
                                              ? _c(
                                                  "div",
                                                  { staticClass: "category" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "category-title"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "FLOOR TO AREA RATIO (FAR)"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    regulation.far.base !== null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "property-row"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v("FAR base")
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "property-value-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      regulation
                                                                        .far
                                                                        .base
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    regulation.far.min !== null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "property-row"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                "FAR minimum"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "property-value-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      regulation
                                                                        .far.min
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    regulation.far.max !== null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "property-row"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                "FAR maximum"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "property-value-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      regulation
                                                                        .far.max
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    regulation.far
                                                      .residential !== null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "property-row"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                "FAR residential"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "property-value-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      regulation
                                                                        .far
                                                                        .residential
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    regulation.far
                                                      .commercial !== null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "property-row"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                "FAR commercial"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "property-value-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      regulation
                                                                        .far
                                                                        .commercial
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    regulation.far.mixed !==
                                                    null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "property-row"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                "FAR mixed"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "property-value-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      regulation
                                                                        .far
                                                                        .mixed
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    regulation.far.note !== null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "property-row"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v("FAR note")
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "property-value-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      regulation
                                                                        .far
                                                                        .note
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            regulation.setbacks.frontMin !==
                                              null ||
                                            regulation.setbacks.frontMax !==
                                              null ||
                                            regulation.setbacks.interiorSide !==
                                              null ||
                                            regulation.setbacks.streetSide !==
                                              null ||
                                            regulation.setbacks.rear !== null ||
                                            regulation.setbacks.rearAlley !==
                                              null ||
                                            regulation.setbacks.rearAlley !==
                                              null ||
                                            regulation.setbacks.generalNote !==
                                              null
                                              ? _c(
                                                  "div",
                                                  { staticClass: "category" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "category-title"
                                                      },
                                                      [_vm._v("SETBACKS")]
                                                    ),
                                                    _vm._v(" "),
                                                    regulation.setbacks
                                                      .frontMin !== null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "property-row"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                "Front minimum"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "property-value-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "integerLg"
                                                                      )(
                                                                        regulation
                                                                          .setbacks
                                                                          .frontMin
                                                                      )
                                                                    ) +
                                                                    " ft\n\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    regulation.setbacks
                                                      .frontMinNote !== null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "property-row"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                "Front minimum note"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "property-value-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      regulation
                                                                        .setbacks
                                                                        .frontMinNote
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    regulation.setbacks
                                                      .frontMax !== null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "property-row"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                "Front maximum"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "property-value-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "integerLg"
                                                                      )(
                                                                        regulation
                                                                          .setbacks
                                                                          .frontMax
                                                                      )
                                                                    ) +
                                                                    " ft\n\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    regulation.setbacks
                                                      .frontMaxNote !== null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "property-row"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                "Front maximum note"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "property-value-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      regulation
                                                                        .setbacks
                                                                        .frontMaxNote
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    regulation.setbacks
                                                      .interiorSide !== null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "property-row"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                "Interior side"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "property-value-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "integerLg"
                                                                      )(
                                                                        regulation
                                                                          .setbacks
                                                                          .interiorSide
                                                                      )
                                                                    ) +
                                                                    " ft\n\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    regulation.setbacks
                                                      .interiorSideNote !== null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "property-row"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                "Interior side note"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "property-value-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      regulation
                                                                        .setbacks
                                                                        .interiorSideNote
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    regulation.setbacks
                                                      .streetSide !== null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "property-row"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                "Street side"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "property-value-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "integerLg"
                                                                      )(
                                                                        regulation
                                                                          .setbacks
                                                                          .streetSide
                                                                      )
                                                                    ) +
                                                                    " ft\n\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    regulation.setbacks
                                                      .streetSideNote !== null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "property-row"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                "Street side note"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "property-value-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      regulation
                                                                        .setbacks
                                                                        .streetSideNote
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    regulation.setbacks.rear !==
                                                    null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "property-row"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v("Rear")
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "property-value-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "integerLg"
                                                                      )(
                                                                        regulation
                                                                          .setbacks
                                                                          .rear
                                                                      )
                                                                    ) +
                                                                    " ft\n\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    regulation.setbacks
                                                      .rearAlley !== null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "property-row"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                "Rear Alley"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "property-value-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "integerLg"
                                                                      )(
                                                                        regulation
                                                                          .setbacks
                                                                          .rearAlley
                                                                      )
                                                                    ) +
                                                                    " ft\n\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    regulation.setbacks
                                                      .rearNote !== null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "property-row"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                "Rear note"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "property-value-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      regulation
                                                                        .setbacks
                                                                        .rearNote
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    regulation.setbacks
                                                      .generalNote !== null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "property-row"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                "General note"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "property-value-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      regulation
                                                                        .setbacks
                                                                        .generalNote
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            regulation.lotCoverage.min !==
                                              null ||
                                            regulation.lotCoverage.max !== null
                                              ? _c(
                                                  "div",
                                                  { staticClass: "category" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "category-title"
                                                      },
                                                      [_vm._v("LOT COVERAGE")]
                                                    ),
                                                    _vm._v(" "),
                                                    regulation.lotCoverage
                                                      .min !== null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "property-row"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                "Lot coverage minimum"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "property-value-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "integerLg"
                                                                      )(
                                                                        regulation
                                                                          .lotCoverage
                                                                          .min
                                                                      )
                                                                    ) +
                                                                    " ft\n\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    regulation.lotCoverage
                                                      .max !== null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "property-row"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                "Lot coverage maximum"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "property-value-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "integerLg"
                                                                      )(
                                                                        regulation
                                                                          .lotCoverage
                                                                          .max
                                                                      )
                                                                    ) +
                                                                    " ft\n\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    regulation.lotCoverage
                                                      .note !== null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "property-row"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                "Lot coverage note"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "property-value-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      regulation
                                                                        .lotCoverage
                                                                        .note
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ])
                                ],
                                1
                              )
                            }),
                            _vm._v(" "),
                            _vm.mode === "regulationAdd"
                              ? _c("regulationForm", {
                                  attrs: {
                                    submitLabel: "Add",
                                    title: "Add Regulation"
                                  },
                                  on: {
                                    close: function($event) {
                                      return _vm.setMode(null)
                                    },
                                    submit: _vm.regulationAdd
                                  }
                                })
                              : _c("div", { staticClass: "mb-3" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-dark btn-sm",
                                      on: {
                                        click: function($event) {
                                          return _vm.setMode("regulationAdd")
                                        }
                                      }
                                    },
                                    [_vm._v("Add Regulation")]
                                  )
                                ]),
                            _vm._v(" "),
                            _vm._l(_vm.zoning.references, function(ref, idx) {
                              return _vm.zoning.references
                                ? _c(
                                    "div",
                                    [
                                      _vm.mode === "referenceDelete" &&
                                      _vm.referenceDeleteInd === idx
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "section section-bold"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "section-title"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\tDelete Reference " +
                                                      _vm._s(idx + 1) +
                                                      "\n\t\t\t\t\t\t\t"
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "category-title-btn",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.setMode(
                                                            null
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons md-14"
                                                        },
                                                        [_vm._v("close")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "section-body" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "property-row"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\tAre you sure you want to delete this reference?\n\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "section-footer"
                                                },
                                                [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-sm btn-danger float-right",
                                                      on: {
                                                        click:
                                                          _vm.referenceDeleteSubmit
                                                      }
                                                    },
                                                    [_vm._v("Delete")]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm.mode === "referenceEdit" &&
                                          _vm.referenceEditInd === idx
                                        ? _c("referenceForm", {
                                            attrs: {
                                              reference:
                                                _vm.zoning.references[idx],
                                              submitLabel: "Save",
                                              title:
                                                "Edit Reference " + (idx + 1)
                                            },
                                            on: {
                                              close: function($event) {
                                                return _vm.setMode(null)
                                              },
                                              submit: _vm.referenceSave
                                            }
                                          })
                                        : _c(
                                            "div",
                                            { staticClass: "section" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "section-title"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\tReference " +
                                                      _vm._s(idx + 1) +
                                                      "\n\t\t\t\t\t\t\t"
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "category-title-btn",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.referenceDelete(
                                                            idx
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons md-14"
                                                        },
                                                        [_vm._v("delete")]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "category-title-btn",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.referenceEdit(
                                                            idx
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons md-14"
                                                        },
                                                        [_vm._v("edit")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "section-body" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "category" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "category-title"
                                                        },
                                                        [_vm._v("DESCRIPTION")]
                                                      ),
                                                      _vm._v(" "),
                                                      ref.description
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "property-row"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t" +
                                                                  _vm._s(
                                                                    ref.description
                                                                  ) +
                                                                  "\n\t\t\t\t\t\t\t\t"
                                                              )
                                                            ]
                                                          )
                                                        : _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "undef"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t-\n\t\t\t\t\t\t\t\t"
                                                              )
                                                            ]
                                                          )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "category" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "category-title"
                                                        },
                                                        [_vm._v("URL")]
                                                      ),
                                                      _vm._v(" "),
                                                      ref.url
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "property-row word-wrap-break"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t" +
                                                                  _vm._s(
                                                                    ref.url
                                                                  ) +
                                                                  "\n\t\t\t\t\t\t\t\t"
                                                              )
                                                            ]
                                                          )
                                                        : _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "undef"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t-\n\t\t\t\t\t\t\t\t"
                                                              )
                                                            ]
                                                          )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            }),
                            _vm._v(" "),
                            _vm.mode === "referenceAdd"
                              ? _c("referenceForm", {
                                  attrs: {
                                    submitLabel: "Add",
                                    title: "Add Reference"
                                  },
                                  on: {
                                    close: function($event) {
                                      return _vm.setMode(null)
                                    },
                                    submit: _vm.referenceAdd
                                  }
                                })
                              : _c("div", { staticClass: "mb-3" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-dark btn-sm",
                                      on: {
                                        click: function($event) {
                                          return _vm.setMode("referenceAdd")
                                        }
                                      }
                                    },
                                    [_vm._v("Add Reference")]
                                  )
                                ])
                          ],
                          2
                        )
                      : _vm._e()
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-049dfb50", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-049dfb50","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/zoning/zoning-edit.vue
// module id = null
// module chunks = 